import create from 'zustand';
type Banner = {
    headerHeight: number;
    setHeaderHeight: (height: number) => void;
};

export const useBannerState = create<Banner>((set) => ({
    headerHeight: 0,
    setHeaderHeight: (height) => set({ headerHeight: height }),
}));
